import { getHeaders, checkStatus } from "../../../shared/services/shared";

// Build a query string from a params object, skipping empty values.
function buildQueryString(params = {}) {
  const query = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&");
  return query ? `?${query}` : "";
}

export async function ingestionQueues(params = {}) {
  return fetch(`${process.env.REACT_APP_API_URL}/genai/job/status${buildQueryString(params)}`, {
    method: "GET",
    headers: await getHeaders({ component: "/user/setting" }),
  })
    .then((response) => {
      if (!response.ok) {
        throw Error("HTTP error, status = " + response.status);
      }
      return response.json();
    })
    .then(checkStatus)
    .catch((error) => {
      return Promise.reject(error);
    });
}

// Fetch the full details (including heavy otherInfo arrays) for a single job by batchId.
export async function jobQueueDetails(batchId) {
  return fetch(
    `${process.env.REACT_APP_API_URL}/genai/job/details${buildQueryString({ batchId })}`,
    {
      method: "GET",
      headers: await getHeaders({ component: "/user/setting" }),
    }
  )
    .then((response) => {
      if (!response.ok) {
        throw Error("HTTP error, status = " + response.status);
      }
      return response.json();
    })
    .then(checkStatus)
    .catch((error) => {
      return Promise.reject(error);
    });
}

// Cancel job queue by jobId and component
export async function cancelJobQueue(params) {
  return fetch(`${process.env.REACT_APP_API_URL}/genai/cancel/job`, {
    method: "POST",
    headers: await getHeaders({ component: params.component }),
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) {
        throw Error("HTTP error, status = " + response.status);
      }
      return response.json();
    })
    .then(checkStatus)
    .catch((error) => {
      return Promise.reject(error);
    });
}
